export const wrapNodeRequest = async <T = unknown>(
    url: string,
    method: 'GET' | 'POST' | 'PUT' | 'DELETE',
    options?: RequestInit,
): Promise<T> => {
    const response = await fetch(url, {
        ...options,
        method,
    })

    const result: T = await response.json()

    return result
}
